

























const DEFAULT_VALUE = 'all'

export default {
  props: {
    options: { type: Object, required: true },
    progress: { type: String, default: DEFAULT_VALUE },
    currentTotalCount: { type: Number, default: 0 },
    progressKey: { type: String, default: 'progress' }
  },
  methods: {
    handleClick(key) {
      const progress = key !== DEFAULT_VALUE ? key : undefined
      const page = this.$route.query.page && this.$route.query.page >= 1 ? 1 : undefined
      this.$router.push({
        query: { ...this.$route.query, page, [this.progressKey]: progress }
      })
    }
  }
}
